/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
"use strict";
/**
 * This class is the implementation to handle the parameters for a plc mapping
 * @class PlcMappingPack
 * @author insite-gmbh
 */
class PlcMappingPack {
}
exports.PlcMappingPack = PlcMappingPack;
